export default __webpack_public_path__ + "static/media/green2-big.07f08537.png";